import { Row } from '../../components/Layout/Row'
import { formatPhoneNumber } from '../../utils/format'
import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { FullSpritzCardFragment } from '../../graphql/generated/graphql'
import {
    Body,
    breakpoints,
    Collapsible,
    CollapsibleMethods,
    colors,
    Spacer,
} from '@spritz-finance/ui'
import { ExpandDetailIcon } from '../../components/ExpandedDetailIcon'
import { CopyIcon, useCopyToClipboard } from '../../utils/useCopyToClipboard'

const AccountDetailsExpandedWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
    gap: 16px;
    border: 1px solid var(--text-secondary, ${colors.ltGrey});
    border-radius: 10px;
`

const AccountDetailsLabel = styled.div`
    font-weight: 500;
    width: 120px;
    margin-right: 16px;

    ${breakpoints.xsmall} {
        margin-bottom: 4px;
    }
`

const AccountDetailsValue = styled.div`
    font-weight: 700;
`

const DetailsItem = styled.div`
    display: flex;
    flex-direction: row;
    ${breakpoints.xsmall} {
        flex-direction: column;
    }
`

export const AccountDetails: React.VFC<{ card: FullSpritzCardFragment }> = ({ card }) => {
    const [open, setOpen] = useState(false)
    const content = useRef<CollapsibleMethods>(null)
    const toggle = () => {
        content.current?.toggle()
        setOpen((curr) => !curr)
    }
    const { copy } = useCopyToClipboard()
    const name = `${card.holderDetails.firstName} ${card.holderDetails.lastName}`
    const phone = formatPhoneNumber(card.holderDetails.phone) as string
    const address = `
            ${card.holderDetails.address.line_1}\t
            ${card.holderDetails.address.city}, ${card.holderDetails.address.state} ${card.holderDetails.address.zip}
    `
    const addressHTML = address.replace('\t', '<br />')

    return (
        <>
            <Row>
                <Body.Med style={{ cursor: 'pointer' }} size={14} onClick={toggle}>
                    Account holder details
                </Body.Med>
                <Spacer width={8} />
                <ExpandDetailIcon
                    active={open}
                    size={24}
                    style={{ marginLeft: -8 }}
                    onClick={toggle}
                />
            </Row>
            <Collapsible ref={content} defaultOpen={false}>
                <Spacer height={16} />
                <AccountDetailsExpandedWrapper>
                    <DetailsItem>
                        <AccountDetailsLabel>Name on card:</AccountDetailsLabel>
                        <Row>
                            <AccountDetailsValue>{name}</AccountDetailsValue>
                            <Spacer width={16} />
                            <CopyIcon onClick={() => copy(name)} />
                        </Row>
                    </DetailsItem>
                    <DetailsItem>
                        <AccountDetailsLabel>Billing address:</AccountDetailsLabel>
                        <Row>
                            <AccountDetailsValue
                                dangerouslySetInnerHTML={{ __html: addressHTML }}
                            />
                            <Spacer width={16} />
                            <CopyIcon onClick={() => copy(address)} />
                        </Row>
                    </DetailsItem>
                    <DetailsItem>
                        <AccountDetailsLabel>Phone number:</AccountDetailsLabel>
                        <Row>
                            <AccountDetailsValue>{phone}</AccountDetailsValue>
                            <Spacer width={16} />
                            <CopyIcon onClick={() => copy(phone)} />
                        </Row>
                    </DetailsItem>
                    {/*<Body.Med>*/}
                    {/*    Learn more about using a crypto-backed virtual card to spend your crypto in*/}
                    {/*    the real world.*/}
                    {/*</Body.Med>*/}
                </AccountDetailsExpandedWrapper>
            </Collapsible>
        </>
    )
}
